import React, { Component } from 'react'
import news1 from '../../assets/img/news1.png'
import news2 from '../../assets/img/news2.png'
import news3 from '../../assets/img/news3.png'
import news4 from '../../assets/img/news4.png'
import cta1 from '../../assets/img/1.png'
import cta2 from '../../assets/img/2.png'
import cta3 from '../../assets/img/3.png'
import cta4 from '../../assets/img/4.png'
import cta5 from '../../assets/img/5.webp'
import cta6 from '../../assets/img/6.webp'
import cta7 from '../../assets/img/7.webp'
import cta8 from '../../assets/img/8.webp'
import cta9 from '../../assets/img/9.webp'
import cta10 from '../../assets/img/10.webp'
import cta11 from '../../assets/img/11.webp'
import cta12 from '../../assets/img/12.webp'
import './footer.css'
import Marquee from 'react-fast-marquee'
import CardRate from './cardRate'
import FaqsComponent from './faqs'
import HowToWorkComponent from './howtowork'
import WhatReceiveComponent from './whatReceive'
import BonusComponent from './bonus'
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown'
import FinalCtaComponent from './finalcta'

const rates = [
  {
    title: '6.5 Kg es un mes, pero lo importante no es el peso',
    description:
      'Llevo perdido 6,5 kg en un mes, pero lo más importante no es el peso. Antes salía a bailar y no podía terminar una canción de 4 minutos porque me faltaba el aire. Ayer pude bailar sin ahogarme y sin cansarme, una canción detrás de otra. Volví a sentirme yo. Me siento feliz de ver estos cambios.',
    name: 'Mireia',
  },
  {
    title: 'Fue el inicio de una transformación',
    description:
      'Me uní al reto solo para obligarme a empezar una dieta que llevaba meses posponiendo. No esperaba gran cosa, pero estaba equivocada. En tres meses he bajado 9 kg, duermo mejor, voy al gimnasio, tengo más energía y dejé de arrastrarme por la vida cansada todo el tiempo. Este reto no fue un impulso: fue el inicio de una transformación que sé que me acompañará siempre. Estoy feliz con todo lo que he logrado.',
    name: 'Hilda',
  },
  {
    title: 'Entendí cómo cuidarme de verdad',
    description:
      'Durante el reto entendí que la ecuación correcta es nutrición, movimiento, descanso y mentalidad. Bajé de 135,8 a 129,3 kg. Después me lesioné y aun así solo subí 0,5 kg. Extraño mis caminatas porque me hacían sentir vivo. Gracias a este proceso entendí cómo cuidarme de verdad. Hoy tengo menos peso y más salud. Gracias por guiarme con un método tan claro.',
    name: 'Luis',
  },
  {
    title: 'Antes la comida me dominaba, ahora decido yo',
    description:
      'Esta semana ha sido espectacular. Reduje el azúcar y la harina un 85 %, aumenté mi consumo de agua y comencé a moverme más. Me siento más ligera y con más control de mi alimentación. Antes la comida me dominaba; ahora yo decido. Estoy lista para seguir avanzando con el plan completo.',
    name: 'Nadia',
  },
  {
    title: 'Siento que por fin avanzo sin obsesionarme',
    description:
      'He perdido 5 kg en menos de un mes y, lo más importante, me siento bien. Estoy aprendiendo cosas que nunca había entendido sobre mi cuerpo y la alimentación. Siento que por fin avanzo sin sufrir y sin obsesionarme. Muy agradecida por todo lo que he descubierto.',
    name: 'María',
  },
  {
    title: 'Aprendí que comer saludable no es aburrido',
    description:
      'Identifiqué creencias limitantes que no sabía que tenía. Pensaba que si no entrenaba fuerte todos los días estaba retrocediendo, pero ahora entiendo la importancia del descanso. También aprendí que comer saludable no es aburrido ni restrictivo; es una forma de cuidar mi cuerpo con conciencia. No estoy pasando hambre, estoy comiendo con inteligencia y propósito. Este proceso me ha cambiado profundamente.',
    name: 'Mayra',
  },
]
class FooterInfo extends Component {
  render() {
    return (
      <>
        <section className="container">
          <div className={'info'}>
            <div className="rates-titles">
              <h2>
                Más de 12.000 personas han conseguido mejorar su salud y
                transformar su cuerpo gracias a un plan de alimentación
                personalizado como el que tú estás a punto de recibir
              </h2>
              <p className="secondary">ESTO ES LO QUE ESTAN DICIENDO</p>
            </div>
            <Marquee pauseOnHover={true}>
              {rates.map((rate) => (
                <CardRate
                  title={rate.title}
                  description={rate.description}
                  name={rate.name}
                />
              ))}
            </Marquee>
            <h1>Algunas transformaciones increibles</h1>
            <div className="container cta footer">
              {/*  <p>
              Aplica para recibir ayuda directa de David y del equipo
              FullMusculo y descubre cómo podemos ayudarte a alcanzar tus metas
              de salud o físicas en tiempo récord. ¡Tu transformación comienza
              aquí!
            </p> */}
              {/*   <a className={'btn-primary'} href="https://bit.ly/formularioR10K">
              EMPIEZA AHORA
            </a> */}
              <Marquee pauseOnHover={true} speed={15}>
                <img className="carousel-image" src={cta1} alt="image1" />
                <img className="carousel-image" src={cta2} alt="image2" />
                <img className="carousel-image" src={cta3} alt="image3" />
                <img className="carousel-image" src={cta4} alt="image4" />
                <img className="carousel-image" src={cta5} alt="image5" />
                <img className="carousel-image" src={cta6} alt="image6" />
              </Marquee>

              <Marquee pauseOnHover={true} direction="right" speed={15}>
                <img className="carousel-image" src={cta7} alt="imag7" />
                <img className="carousel-image" src={cta8} alt="image8" />
                <img className="carousel-image" src={cta9} alt="image9" />
                <img className="carousel-image" src={cta10} alt="image10" />
                <img className="carousel-image" src={cta11} alt="image11" />
                <img className="carousel-image" src={cta12} alt="image12" />
              </Marquee>
            </div>
            <HowToWorkComponent />
            <WhatReceiveComponent />
            <BonusComponent />
            <div className="info-news">
              <h1
                style={{
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  marginBottom: '2rem',
                }}
              >
                HEMOS SIDO PRESENTADOS POR
              </h1>
              <div className="images-container">
                <img src={news1} alt="news" />
                <img src={news2} alt="news" style={{ width: '150px' }} />
                <img src={news3} alt="news" style={{ width: '290px' }} />
                <img src={news4} alt="news" />
              </div>
            </div>
          </div>
        </section>
        <div>
          <FinalCtaComponent />
        </div>
        <section className="container">
          <div className="faqs">
            <FaqsComponent />
          </div>
        </section>
      </>
    )
  }
}

export default FooterInfo
